import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { StateCreator } from 'zustand';

type IdleSessionState = {
  /**
   * idle 로직을 멈추도록 할 때 사용합니다.
   * @default false
   */
  isPauseExpired: boolean;
  /**
   * iam domain 정보에 등록된 session timeout mins 설정이 아닌 서비스 개별 커스텀 session timeout 설정이 필요한 경우 사용합니다.
   * minutes (분) 단위로 전달합니다.
   * @default undefined
   */
  sessionExpireTimeMins?: number;
};

type IdleSessionActions = {
  setIsPauseExpired: (val: boolean) => void;
  setSessionExpireTimeMins: (val: number) => void;
};

type IdleSessionStore = IdleSessionState & IdleSessionActions;

const STORE_NAME = 'IDLE_SESSION';
const KEYS = {
  SET_IS_PAUSE_EXPIRED: `${STORE_NAME}/setIsPauseExpired`,
  SET_SESSION_EXPIRE_TIME_MINS: `${STORE_NAME}/setSessionExpireTimeMins`,
};

const initState: IdleSessionState = {
  isPauseExpired: false,
  sessionExpireTimeMins: undefined,
};

const createIdleSessionSlice: StateCreator<
  IdleSessionStore,
  [['zustand/devtools', never]],
  [],
  IdleSessionStore
> = set => ({
  ...initState,
  setIsPauseExpired: val =>
    set(state => ({ ...state, isPauseExpired: val }), undefined, KEYS.SET_IS_PAUSE_EXPIRED),
  setSessionExpireTimeMins: val =>
    set(
      state => ({ ...state, sessionExpireTimeMins: val }),
      undefined,
      KEYS.SET_SESSION_EXPIRE_TIME_MINS,
    ),
});

export const useIdleSessionStore = create<IdleSessionStore>()(
  devtools((...args) => ({
    ...createIdleSessionSlice(...args),
  })),
);
